import createVueComponent from '../createVueComponent';

const DownloadCloud = createVueComponent('DownloadCloudIcon', [
  ['path', { d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9' }],
  ['path', { d: 'M12 12v9' }],
  ['path', { d: 'M8 17l4 4 4-4' }],
]);

export default DownloadCloud;
